
import { Vue, Options } from "vue-class-component";
import { formatCompactNumber } from "@/app/infrastructures/misc/Utils";
import { CargoV2Controller } from "@/app/ui/controllers/CargoV2Controller";
import router from "@/app/ui/router";
import { CargoFailedUnread } from "@/domain/entities/Cargo";
import { FailedUnreadRequest } from "@/data/payload/api/CargoApiRequest";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";

@Options({})
class CargoV2Index extends Vue {
  get tabs(): { name: string; title: string }[] {
    const summaryInProcess =
      CargoV2Controller.summaryInProcessValue.inProcessTotal;
    return [
      {
        name: "cargo-v2-booking-success",
        title: this.$t("cargo.tabs.bookingSuccess")
      },
      {
        name: "cargo-v2-booking-in-progress",
        title: this.$t("cargo.tabs.bookingInProgressWithCount", {
          count: formatCompactNumber(summaryInProcess)
        })
      },
      {
        name: "cargo-v2-booking-cancelled",
        title: this.$t("cargo.tabs.bookingCanceled")
      }
    ];
  }

  get hasNewCanceledFailed(): boolean {
    return CargoV2Controller.cargoFailedUnreadData.isShow;
  }

  unreadInInterval: ReturnType<typeof setInterval> | null = null;

  changeTabs(name: string): void {
    if (name === "cargo-v2-booking-cancelled") {
      CargoV2Controller.setCargoFailedUnreadData(
        new CargoFailedUnread({
          isShow: false,
          newRcId: CargoV2Controller.cargoFailedUnreadData.newRcId
        })
      );
      this.getCargoFailedUnread("read");
    } else {
      this.initiateGetCargoFailedUnread();
    }

    const pathMap: Record<string, string> = {
      "cargo-v2-booking-success": "/cargo-v2/booking-success",
      "cargo-v2-booking-in-progress": "/cargo-v2/booking-in-progress",
      "cargo-v2-booking-cancelled": "/cargo-v2/booking-cancelled"
    };
    const path = pathMap[name];
    if (path) {
      router.push(path);
      CargoV2Controller.setActiveTab(name);
    }

    CargoV2Controller.getCargoSummaryInProcess();
  }

  isTabActive(name: string): boolean {
    return name === this.$route.name;
  }

  getCargoFailedUnread(action: string): void {
    const hubId = getHubData()?.hubId;
    const params = new FailedUnreadRequest({
      hubId: hubId ? Number(hubId) : 0,
      action
    });
    CargoV2Controller.getCargoFailedUnread(params);
  }

  initiateGetCargoFailedUnread(): void {
    this.stopUnreadInterval();
    this.unreadInInterval = setInterval(
      () => this.getCargoFailedUnread("list"),
      FlagsPermissionCargo.config_booking_failed_indicator_pooling_rate.getValue()
    );
  }

  stopUnreadInterval(): void {
    if (this.unreadInInterval) {
      clearInterval(this.unreadInInterval);
      this.unreadInInterval = null;
    }
  }

  mounted(): void {
    this.initiateGetCargoFailedUnread();
    CargoV2Controller.getCargoSummaryInProcess();
  }

  unmounted(): void {
    this.stopUnreadInterval();
  }
}

export default CargoV2Index;
